export default __webpack_public_path__ + "static/media/logoMenuDark.86b0b217.svg";